module.exports = __webpack_public_path__ + "static/img/9_1.a4b4db6b.jpg";